'use client';



const WhatVeriqonProvidesSection = () => {
  const provisions = [
  {
    icon: 'DocumentCheckIcon',
    title: 'Complete Codebase Understanding',
    description: 'Get a comprehensive overview of your entire system architecture, dependencies, and structure without manual documentation.'
  },
  {
    icon: 'ChartBarIcon',
    title: 'Real-Time Change Tracking',
    description: 'Monitor how your codebase evolves over time with automatic detection of structural changes and complexity growth.'
  },
  {
    icon: 'ShieldCheckIcon',
    title: 'Risk Assessment & Visibility',
    description: 'Identify fragile areas, frequently changing components, and sections that may require attention before they become problems.'
  },
  {
    icon: 'UsersIcon',
    title: 'Team Knowledge Preservation',
    description: 'Maintain context and understanding across team changes, ensuring knowledge doesn\'t walk out the door with departing developers.'
  },
  {
    icon: 'LightBulbIcon',
    title: 'Actionable Engineering Insights',
    description: 'Receive clear signals about your codebase health, helping teams make better technical decisions with confidence.'
  },
  {
    icon: 'ClockIcon',
    title: 'Accelerated Onboarding',
    description: 'New team members get up to speed faster with a clear, current picture of the system they\'re joining.'
  }];


  return;







































};

export default WhatVeriqonProvidesSection;